import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Contract} from '../../../model/Entities/Contract';

@Component({
    selector: 'eshop-hide-confirm-dialog',
    templateUrl: './eshop-hide-confirm.dialog.component.html',
    styleUrls: ['./eshop-hide-confirm.dialog.component.scss']
})
export class EshopHideConfirmDialogComponent {

    contract: Contract;

    constructor(public dialog: MatDialogRef<EshopHideConfirmDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.contract = data.contract;
    }
}




// WEBPACK FOOTER //
// /app/src/DashboardModule/DashboardComponent/EshopHideConfirmDialogComponent/eshop-hide-confirm.dialog.component.ts